export default __webpack_public_path__ + "static/media/icon.tactical first aid kits.87372ab7.svg";